import KitchenIcon from "@mui/icons-material/Kitchen";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SoupKitchenIcon from '@mui/icons-material/SoupKitchen';

import { routes } from "../routing/routes";

export const UserNavTabs = [
  {
    id: "saviruchiImage", 
    label: "SaviRuchi",
    icon: <SoupKitchenIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.SAVIRUCHIIMAGE,
  },

  {
    id: "userTransaction",
    label: "Transaction",
    icon: <LocationCityIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.USER_TRANSACTION,
  },
  
  {
    id: "userWallet",
    label: "Wallet",
    icon: <KitchenIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.WALLET,
  },
  {
    id: "userProfile",
    label: "Profile",
    icon: <AccountBoxIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.USER_PROFILE,
  },
];
